<template>
	<div>
		<StrapiTable v-bind="table">
			<AdminAccountsTableRow
				v-for="i in items"
				:key="i.id"
				v-bind="i"
				@remove="onRequestRemove"
			/>
		</StrapiTable>
		<Modal v-if="confirmRemove" @close="cancelRemove">
			<h2>Confirm account deletion</h2>
			<p>
				Are you sure you want to delete the account for
				<strong>{{ toRemove.username }}</strong> ({{ toRemove.email }})?
			</p>
			<p>This action is not reversible.</p>
			<button class="delete-button" @click="remove(toRemove)">
				Delete account
			</button>
		</Modal>
	</div>
</template>

<script>
import api from '@/mixins/api'
import toast from '@/mixins/toast'
import Modal from '@/components/admin/Modal'
import StrapiTable from '@/components/admin/StrapiTable'
import AdminAccountsTableRow from '@/components/admin/AdminAccountsTableRow'
import table from '@/mixins/table'

const tableMixin = table([
	{ column: 'username', label: 'Name' },
	{ column: 'email', label: 'Email' },
	{ column: 'created_at', label: 'Created', sort: 'DESC' },
	{ label: 'Actions' }
])

export default {
	name: 'AdminAccountsTable',
	data() {
		return {
			toRemove: null,
			removing: false
		}
	},
	computed: {
		confirmRemove() {
			return this.toRemove !== null
		}
	},
	methods: {
		cancelRemove() {
			this.toRemove = null
		},
		onRequestRemove(account) {
			this.toRemove = account
		},
		async remove({ id, username }) {
			// Delete a user account
			try {
				await this.delete(`/users/${id}`)
				this.toast(`Successfully *deleted* the account for *${username}*.`)
				this.cancelRemove()
				this.refresh()
			} catch (err) {
				this.toastErr('Failed to delete this account. Please try again later.')
			}
		}
	},
	mixins: [api, toast, tableMixin],
	components: {
		Modal,
		StrapiTable,
		AdminAccountsTableRow
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
@import '~scss/mq';

.delete-button {
	@include button($red-85, $grey-95, $white, $red-85);
	width: 100%;

	@include mq(md) {
		width: auto;
		& + & {
			margin: 0 0 0 1rem;
		}
	}
}
</style>
